import { useMutation } from 'react-query';
import { getProductReservationApi } from '../../../../../../config/SwaggerProductReservationApi';

const deleteDocumentLinkManagement = (id: string) =>
    getProductReservationApi()
        .documentLinkSetting.deleteDelete(id)
        .then((response) => response.data);

const useDeleteDocumentLinkManagement = () => {
    const useDeleteDocumentLinkManagementMutation = useMutation(deleteDocumentLinkManagement);

    return useDeleteDocumentLinkManagementMutation;
};

export default useDeleteDocumentLinkManagement;
